export default "__VITE_ASSET__156ecd3b__"